import React, { JSX, PropsWithChildren } from 'react'
import './index.scss'
import clsx from 'clsx'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

interface DashboardKpiCardProps {
    title: string
    data: string | number
    className?: string | undefined
    noDataInfo?: JSX.Element
    tooltipContent?: string
}
const DashboardKpiCard = ({
    title,
    data,
    className,
    noDataInfo,
    tooltipContent,
    children,
}: PropsWithChildren<DashboardKpiCardProps>) => (
    <div className={clsx('dashboard-content-card', 'kpi-card', className)}>
        <div className="kpi-card-title">
            {title} {tooltipContent && <CustomToolTip info={tooltipContent} type="?" inverse />}
        </div>
        {noDataInfo ?? (
            <>
                <div className="kpi-card-data">{data}</div>
            </>
        )}
        {children}
    </div>
)

export default DashboardKpiCard
